export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14721.ab7aa548.jpg";